var React = require('react');

function Users (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"className":"background","fill":"#EDE7F6","cx":"20","cy":"20","r":"20","key":0}),React.createElement("g",{"fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M23.25 21.25h-.652a6.807 6.807 0 0 1-5.696 0h-.652A5.251 5.251 0 0 0 11 26.5v1.625C11 29.16 11.84 30 12.875 30h13.75c1.035 0 1.875-.84 1.875-1.875V26.5a5.251 5.251 0 0 0-5.25-5.25z","fill":"#B39DDB","key":0}),React.createElement("path",{"className":"foreground","d":"M19.75 20a5 5 0 1 0 0-10 5 5 0 0 0 0 10z","fill":"#673AB7","key":1})])]));
}

Users.defaultProps = {"width":"40","height":"40"};

module.exports = Users;

Users.default = Users;
